import { TooltipHost } from '@fluentui/react';
import {
    ColumnWrapper,
    CircleWrapper,
    Circle,
} from '../../instalationPointsList.styles';
import { tdProgressMessages } from '../../../../../../../../utils/tdSensorHelpers/tdProgressMessages';

/**
 *  Компонент для отрисовки прогресс бара для датчика TD
 * @param {object} selectedSensor объект выбранного сенсора
 */
const TdProgressColumn = ({ selectedSensor }) => {
    return (
        <ColumnWrapper>
            <CircleWrapper>
                <TooltipHost
                    content={
                        selectedSensor
                            ? !selectedSensor.firstStepError
                                ? tdProgressMessages.firstStepEnabled
                                : selectedSensor.firstStepError
                            : null
                    }
                >
                    <Circle
                        newColor={
                            selectedSensor
                                ? selectedSensor.isFetching
                                    ? 'grey'
                                    : !selectedSensor.firstStepError
                                    ? 'green'
                                    : 'red'
                                : 'grey'
                        }
                    >
                        1
                    </Circle>
                </TooltipHost>
            </CircleWrapper>
            <CircleWrapper>
                <TooltipHost
                    content={
                        selectedSensor
                            ? !selectedSensor.secondStepError
                                ? tdProgressMessages.secondStepEnabled
                                : selectedSensor.secondStepError
                            : null
                    }
                >
                    <Circle
                        newColor={
                            selectedSensor
                                ? selectedSensor.isFetching
                                    ? 'grey'
                                    : !selectedSensor.secondStepError
                                    ? 'green'
                                    : 'red'
                                : 'grey'
                        }
                    >
                        2
                    </Circle>
                </TooltipHost>
            </CircleWrapper>
            <CircleWrapper>
                <TooltipHost
                    content={
                        selectedSensor
                            ? !selectedSensor.thirdStepError
                                ? tdProgressMessages.thirdStepEnabled
                                : selectedSensor.thirdStepError
                            : null
                    }
                >
                    <Circle
                        newColor={
                            selectedSensor
                                ? selectedSensor.isFetching
                                    ? 'grey'
                                    : !selectedSensor.thirdStepError
                                    ? 'green'
                                    : 'red'
                                : 'grey'
                        }
                    >
                        3
                    </Circle>
                </TooltipHost>
            </CircleWrapper>
        </ColumnWrapper>
    );
};

export default TdProgressColumn;
